const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.93,347.17a25.86,25.86,0,0,1-5.36,11.51c-4.55,5.63-10.71,16.61-11,27.05s-12.33,39.33-11,41.47,13.12,5.09,17.67,5.09c2.39,0,6.35.92,7.93-1.41.09-.13-9.35-5-10-5.47s-5.91-4.17-5.74-4.64c0,0,12.34-33.44,18.5-42s10.71-15,12.58-20.35S231.06,348,231.06,348Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.68,349.36a25.87,25.87,0,0,1,5,11.68c1.13,7.15,5.17,19.07,12.76,26.26s21,37.43,23.48,37.86c2.91.52,7.35-3.2,9.51-4.71,2.75-1.92,9.06-5.84,10-9.23,1.13-3.9-2.88-1.94-4.57-.68-2.19,1.63-13.12,3-13.12,3S279.13,380,276.89,369.7s-4-18-6.71-23-5.43-9.57-5.43-9.57Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.29,293.73,205,345a70.74,70.74,0,0,0,13.31,6.66c7.32,2.66,20,2,20,2l5-24.95,2,23.29s9.65,1,16.64-.33,18.3-8.66,18.3-8.66l-22-40.92-5-9.65-38.93-1Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233,175s-3.33-4-5.32-2.33-1.34,6.33,1,8.66,5.33.33,5.33.33,1.33,4.32,3.66,6.32,10.31,3.33,13,1.33,1.66-9.32,1.66-9.32,4.66-2.33,4.33-4-3.67-3-3.67-4.32a18.49,18.49,0,0,0-.33-3V166l-15.3,3.33S235.35,177,233,175Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.31,271.6c-6.24-4.82-12.61-9.49-16.36-16.46-19-35.27,20.55-76.53-1.4-114.75C407.41,121,385.44,106.81,364,114.87c-22.85,8.6-44.42,17.58-69,10.47-43-12.46-65.33-70.76-112.17-69.78-38.45.8-81.24,41.3-59,83.33,16.85,31.8,6.32,58.12-32.65,63.6S35.45,254,47,273.77s33.69,40.57,12.63,49.34-28.43,37.28-26.32,57,6.31,27.41,6.31,27.41H443.84s17.05-21.93,19.15-72.36c.92-21.86-3.61-43.27-20.13-58.22C440.77,275.08,438.55,273.33,436.31,271.6Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.31,271.6c-6.24-4.82-12.61-9.49-16.36-16.46-19-35.27,20.55-76.53-1.4-114.75C407.41,121,385.44,106.81,364,114.87c-22.85,8.6-44.42,17.58-69,10.47-43-12.46-65.33-70.76-112.17-69.78-38.45.8-81.24,41.3-59,83.33,16.85,31.8,6.32,58.12-32.65,63.6S35.45,254,47,273.77s33.69,40.57,12.63,49.34-28.43,37.28-26.32,57,6.31,27.41,6.31,27.41H443.84s17.05-21.93,19.15-72.36c.92-21.86-3.61-43.27-20.13-58.22C440.77,275.08,438.55,273.33,436.31,271.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.56,
    cy: 432,
    rx: 76.5,
    ry: 8,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.56,
    cy: 432,
    rx: 76.5,
    ry: 8,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "418.43 365.9 418.43 353.69 404.81 353.69 404.81 330 385.24 330 385.24 233.78 366.52 233.78 366.52 291.94 349.5 291.94 349.5 271.12 326.53 271.12 326.53 324.97 317.17 324.97 317.17 342.2 295.05 342.2 295.05 335.74 301.85 335.74 301.85 332.15 273.77 332.15 273.77 336.46 277.18 336.46 277.18 355.13 262.71 355.13 262.71 319.94 211.66 319.94 211.66 345.07 175.06 345.07 175.06 326.4 161.45 326.4 161.45 347.23 132.52 347.23 132.52 309.17 120.61 309.17 120.61 296.25 99.33 296.25 99.33 355.13 78.06 355.13 78.06 368.05 64.45 368.05 64.45 407.54 444.81 407.54 444.81 365.9 418.43 365.9",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 309,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 309,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 318.59,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 318.59,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.03,
    y: 318.59,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.03,
    y: 328.17,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.03,
    y: 337.76,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.03,
    y: 347.34,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.03,
    y: 356.93,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.03,
    y: 366.52,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 328.17,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 328.17,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 337.76,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 337.76,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 347.34,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 347.34,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 356.93,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.01,
    y: 362.3,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.34,
    y: 351.94,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.54,
    y: 351.94,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 239.21,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 239.21,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 248.8,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 248.8,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 258.39,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 258.39,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 267.97,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 267.97,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 277.56,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 277.56,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 287.14,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 287.14,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 296.73,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 296.73,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 306.32,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 306.32,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 315.9,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 315.9,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.47,
    y: 315.9,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 315.9,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.41,
    y: 315.9,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.47,
    y: 336.61,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 336.61,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.41,
    y: 336.61,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.47,
    y: 357.31,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.44,
    y: 357.31,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.41,
    y: 357.31,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 325.49,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 325.49,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 335.07,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 335.07,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 344.66,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 344.66,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.92,
    y: 335.07,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.66,
    y: 335.07,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.92,
    y: 344.28,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.66,
    y: 344.28,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.92,
    y: 353.48,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.66,
    y: 353.48,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.92,
    y: 362.68,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.66,
    y: 362.68,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 354.25,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 354.25,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.58,
    y: 363.83,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 363.83,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 356.93,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 366.52,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 366.52,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 376.1,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 376.1,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 385.69,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 385.69,
    width: 4.6,
    height: 4.6,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "359.61 388.57 359.61 407.54 321.27 407.54 321.27 369.82 359.61 369.82 359.61 385.19",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "430.17 401.81 430.17 407.54 391.82 407.54 391.82 387.6 399.74 387.6",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "404.41 387.6 430.17 387.6 430.17 398.7",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "147.56 387.6 174.8 387.6 174.8 407.54 136.45 407.54 136.45 387.6 143.92 387.6",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "87.57 387.6 91.21 387.6 91.21 407.54 77.02 407.54 77.02 387.6 84.71 387.6",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.37,
    y: 369.82,
    width: 6.13,
    height: 37.72,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "295.85 374.95 289.83 374.95 289.83 364.98 310.15 364.98 310.15 374.95 301.31 374.95",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.83,
    y: 358.08,
    width: 23.39,
    height: 8.44,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.95,
    y: 358.08,
    width: 2.3,
    height: 49.46,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Location--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,57.63a129,129,0,0,0-129,129c0,64.35,119,216,119,216h10s129-144.76,129-216A129,129,0,0,0,250,57.63Zm0,192a63,63,0,1,1,63-63A63,63,0,0,1,250,249.63Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,57.63a129,129,0,0,0-129,129c0,71.24,129,216,129,216s129-144.76,129-216A129,129,0,0,0,240,57.63Zm0,192a63,63,0,1,1,63-63A63,63,0,0,1,240,249.63Z",
    style: {
      fill: "#92E3A9",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.43 265.25 213.68 241 213.93 249.75 205.43 266.75 199.43 265.25",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.93,347.17a25.86,25.86,0,0,1-5.36,11.51c-4.55,5.63-10.71,16.61-11,27.05s-12.33,39.33-11,41.47,13.12,5.09,17.67,5.09c2.39,0,6.35.92,7.93-1.41.09-.13-9.35-5-10-5.47s-5.91-4.17-5.74-4.64c0,0,12.34-33.44,18.5-42s10.71-15,12.58-20.35S231.06,348,231.06,348Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.58,355.82a66.29,66.29,0,0,0,16.2,4.61c.3-.69.57-1.36.8-2,1.88-5.36,3.48-10.45,3.48-10.45l-17.13-.8A25.16,25.16,0,0,1,210.58,355.82Z",
    style: {
      fill: "#92E3A9",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.93,347.17a25.86,25.86,0,0,1-5.36,11.51c-4.55,5.63-10.71,16.61-11,27.05s-12.33,39.33-11,41.47,13.12,5.09,17.67,5.09c2.39,0,6.35.92,7.93-1.41.09-.13-9.35-5-10-5.47s-5.91-4.17-5.74-4.64c0,0,12.34-33.44,18.5-42s10.71-15,12.58-20.35S231.06,348,231.06,348Z",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,349.36a25.87,25.87,0,0,1,5,11.68c1.13,7.15,5.17,19.07,12.76,26.26s21,37.43,23.48,37.86c2.91.52,7.35-3.2,9.51-4.71,2.75-1.92,9.06-5.84,10-9.23,1.13-3.9-2.88-1.94-4.57-.68-2.19,1.63-13.12,3-13.12,3S279.13,380,276.89,369.7s-4-18-6.71-23-5.43-9.57-5.43-9.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.18,346.73c-2.73-5-5.44-9.57-5.44-9.57l-12.06,12.2a25.34,25.34,0,0,1,4.39,9,99.46,99.46,0,0,0,16-4.25A38.92,38.92,0,0,0,270.18,346.73Z",
    style: {
      fill: "#92E3A9",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.68,349.36a25.87,25.87,0,0,1,5,11.68c1.13,7.15,5.17,19.07,12.76,26.26s21,37.43,23.48,37.86c2.91.52,7.35-3.2,9.51-4.71,2.75-1.92,9.06-5.84,10-9.23,1.13-3.9-2.88-1.94-4.57-.68-2.19,1.63-13.12,3-13.12,3S279.13,380,276.89,369.7s-4-18-6.71-23-5.43-9.57-5.43-9.57Z",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,411.22c1.13-3.9-2.88-1.94-4.57-.68-2.19,1.63-13.12,3-13.12,3s-1.18-2.6-2.9-6.52a29,29,0,0,1-7,4.09c3.75,7.39,6.86,13.88,8.08,14.09,2.91.52,7.35-3.2,9.51-4.71C306.16,418.53,312.47,414.61,313.44,411.22Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.29,293.73,205,345a70.74,70.74,0,0,0,13.31,6.66c7.32,2.66,20,2,20,2l5-24.95,2,23.29s9.65,1,16.64-.33,18.3-8.66,18.3-8.66l-22-40.92-5-9.65-38.93-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.63,323.16c3.38-4.23,4.6-29.1,4.6-29.1l-33.94-2.57v2.24L210.05,317C219.55,320.06,241,326.44,243.63,323.16Z",
    style: {
      fill: "#92E3A9",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.29,293.73,205,345a70.74,70.74,0,0,0,13.31,6.66c7.32,2.66,20,2,20,2l5-24.95,2,23.29s9.65,1,16.64-.33,18.3-8.66,18.3-8.66l-22-40.92-5-9.65-38.93-1Z",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.68 253.25 290.68 258.25 298.43 235.25 269.43 229.75 262.93 251 271.68 253.25",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.39,
    y1: 242.61,
    x2: 287.47,
    y2: 245.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.22,
    y1: 245.56,
    x2: 286.3,
    y2: 248.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.93,254.5s6-3.25,8-6,4.25-7.5,5.25-8.25,6-3.25,7-4,2.5.75.75,2.25-5.5,4.75-5.5,4.75,1,4.5-.25,6a15.13,15.13,0,0,1-2.25,2.25l6.75,1.75s-4.5,3.25-6.5,3.75a46,46,0,0,1-6,.75l-8.25,6.5Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,199.89s-8,11.65-10,25.29-.66,68.55-.66,68.55,10.64,4.32,19,4.32,20.63.67,21-4-2.33-58.23-6-71.21a95.83,95.83,0,0,0-11-24S228.93,193.23,224.93,199.89Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.18 210 232.43 278.5 241.93 282 246.18 216.25 243.18 210",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.38,173.35s1.33,6.32,4,9.65,7.65,5,7.65,5l-1.43,7.57,9.32,5.66L242.34,185l1-19.3S220,169.69,219.38,173.35Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.38,173.35s1.33,6.32,4,9.65,7.65,5,7.65,5,8-2.33,8.65-7.65c.48-3.84-.24-10.43-.69-13.82C232.2,167.87,219.86,170.7,219.38,173.35Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,175s-3.33-4-5.32-2.33-1.34,6.33,1,8.66,5.33.33,5.33.33,1.33,4.32,3.66,6.32,10.31,3.33,13,1.33,1.66-9.32,1.66-9.32,4.66-2.33,4.33-4-3.67-3-3.67-4.32a18.49,18.49,0,0,0-.33-3V166l-15.3,3.33S235.35,177,233,175Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-1--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.35,169.36a20.36,20.36,0,0,1-1.86,4.61c6-.27,12.41-.65,18.15-1.15a1.81,1.81,0,0,1-.66-1.13,18.49,18.49,0,0,0-.33-3V166Z",
    style: {
      fill: "#92E3A9",
      mixBlendMode: "multiply"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M233,175s-3.33-4-5.32-2.33-1.34,6.33,1,8.66,5.33.33,5.33.33,1.33,4.32,3.66,6.32,10.31,3.33,13,1.33,1.66-9.32,1.66-9.32,4.66-2.33,4.33-4-3.67-3-3.67-4.32a18.49,18.49,0,0,0-.33-3V166l-15.3,3.33S235.35,177,233,175Z",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.38,173.35,252.65,166s-4.66-16.31-10.31-17.64-16.64-2-22.63,4S219.38,173.35,219.38,173.35Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.67,168.69a97.07,97.07,0,0,0,13.31,2c6,.33,19.63-5,16.31-5.33s-18.64.67-18.64.67Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.27 192.9 223.27 199.56 238.25 208.87 241.24 199.56 226.27 192.9",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.43,262.5l53.25,13.75-5.53,38.94a4.56,4.56,0,0,1-5.67,3.77l-48.41-12.58a3.61,3.61,0,0,1-2.62-4.29Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.43,262.5S208,293,215.7,297s33-20.72,33-20.72",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,249.14s-3.33,7.32-2.33,10,42.26,17.64,42.26,17.64.33,5.65,1.33,7a20.57,20.57,0,0,1,2,4.66s-2,4.66-1,5.66,4-4.66,4-6.32.33-10.65-.66-13-29.29-19.63-29.29-19.63Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "224.27 209.21 204.97 250.13 222.27 255.13 236.25 222.52",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.27,
    y1: 255.13,
    x2: 235.01,
    y2: 226.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.64,
    y1: 237.05,
    x2: 237.05,
    y2: 230.64,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.64,343.93a48.92,48.92,0,0,0,25.94,5.37",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.3,341.31s.77.58,2.2,1.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.16,341.58a39.82,39.82,0,0,0,3.69-2.27",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,348a58.21,58.21,0,0,0,22.66-4.92",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.24,
    y1: 328.67,
    x2: 250.42,
    y2: 316.24,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.63,
    y1: 328.02,
    x2: 255.6,
    y2: 314.45,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.1,322.63l-1,7.38a30.55,30.55,0,0,0,8,4c4.79,1.6,15,1.4,15,1.4l1.4-7s-17.76-2-21.35-5",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.91,332.8s-2.8,6.79-1,8.39,14.56,6.38,18,6,5.38-8.78,5.38-8.78",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,411.22c1.13-3.9-2.88-1.94-4.57-.68-2.19,1.63-13.12,3-13.12,3l-1.33-3a23.1,23.1,0,0,1-6.78,4.14c2.91,5.78,5.24,10.32,6.26,10.49,2.91.52,7.35-3.2,9.51-4.71C306.16,418.53,312.47,414.61,313.44,411.22Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.13,416.68c-4.5,2.34-9.75,5.18-12.78,6.77.66,1,1.19,1.65,1.55,1.71,2.91.52,7.35-3.2,9.51-4.71,2.75-1.92,9.06-5.84,10-9.23.48-1.64,0-2.24-.75-2.29C311,411.71,308.42,415,305.13,416.68Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.24,425.41c-.48-.36-5.91-4.17-5.74-4.64,0,0,1.09-2.93,2.76-7.27a31.2,31.2,0,0,1-8.32-2.24c-2.66,8.08-5,14.94-4.34,15.94,1.33,2.14,13.12,5.09,17.67,5.09,2.39,0,6.35.92,7.93-1.41C212.29,430.75,202.85,425.86,202.24,425.41Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2,430.88c.09-.13-9.35-5-10-5.47s-5.91-4.17-5.74-4.64l1.06-2.83a42.59,42.59,0,0,1-8.06-2.3c-2,6.06-3.41,10.74-2.9,11.56,1.33,2.14,13.12,5.09,17.67,5.09C206.66,432.29,210.62,433.21,212.2,430.88Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.84,430.08c-6.13-.37-12.94-2.89-16.27-4.27a2.46,2.46,0,0,0,0,1.39c1.33,2.14,13.12,5.09,17.67,5.09,2.39,0,6.35.92,7.93-1.41a9.82,9.82,0,0,0-1.41-.83A57.05,57.05,0,0,1,202.84,430.08Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.94,
    y1: 168.72,
    x2: 234.6,
    y2: 156.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,153.7s-1.67-3.68-.33-5.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBro);
export default __webpack_public_path__ + "static/media/Address-bro.a045e7ca45d185dfe3a53dd7ae605dd4.svg";
export { ForwardRef as ReactComponent };